import React from 'react';
import { Controller } from 'react-hook-form';
import CustomLabel from 'components/customLabel';
import ErrorMessage from 'components/errorMessage';
import { InputStyle } from 'components/InitialStyle';
import { Box, InputAdornment, TextField } from '@mui/material';

type ComponentTypes = {
  name?: any;
  error?: any;
  styles?: any;
  control?: any;
  label?: string;
  onClickIcon?: any;
  maxLength?: number;
  disabled?: boolean;
  required?: boolean;
  defaultValue?: any;
  placeholder?: string;
  icon?: React.ReactElement;
  startIcon?: React.ReactElement;
  type?: 'email' | 'password' | 'text' | 'number';
};

const CustomInput = ({
  icon,
  name,
  type,
  error,
  styles,
  control,
  disabled,
  startIcon,
  maxLength,
  label = '',
  placeholder,
  defaultValue,
  required = true,
}: ComponentTypes) => {
  return (
    <Box width='100%' position='relative'>
      <CustomLabel htmlFor={label}>{label}</CustomLabel>

      <Controller
        name={name}
        control={control}
        rules={{
          required: required && 'Поле обязательное для заполнения',
          pattern: {
            value: /^(?!\s)(.*\S)?$/, // Boshida va oxirida probel bo'lmasin
            message: 'Поле не должно начинаться или заканчиваться пробелом.',
          },
        }}
        defaultValue={defaultValue}
        render={({ field }) => (
          <TextField
            disabled={disabled}
            {...field}
            id={label}
            type={type}
            placeholder={placeholder}
            value={field.value || ''}
            fullWidth
            onWheel={(e: any) => e.target.blur()}
            sx={{
              ...InputStyle,
              ...styles,
              '.MuiInputBase-input': {
                padding: startIcon ? '8.5px 0' : '8.5px 10px',
              },
            }}
            error={Boolean(error?.[name])}
            InputProps={{
              autoComplete: 'new-password',
              inputProps: { max: maxLength && maxLength, min: 0 },
              startAdornment: startIcon && (
                <InputAdornment sx={{ ml: 0 }} position='start'>
                  {startIcon}
                </InputAdornment>
              ),
              endAdornment: icon && (
                <InputAdornment sx={{ color: '#C0C0C0' }} position='end'>
                  {icon}
                </InputAdornment>
              ),
            }}
          />
        )}
      />
      <span style={{ color: 'red', fontSize: '12px', position: 'absolute', left: 0, bottom: -15 }}>
        {error?.type === 'required' && error?.message}
      </span>
      <ErrorMessage error={error} name={name} />
    </Box>
  );
};

export default CustomInput;
